import { StatusColor } from './types';

export const COLOR_CLASSES: {
    [key in StatusColor]: string;
} = {
    green: 'u-color--positive',
    orange: 'u-color--attention',
    grey: 'u-color--grey-50',
    purple: 'u-color--progression',
    red: 'u-color--alert',
};
